// /library — real route (design doc's G2). Thin-server-shell parity: the
// original (app/library/page.tsx:11-19) is just
// `getEffectiveUserId() -> redirect('/sign-in?...') -> <LibraryClient/>`;
// the redirect-if-signed-out half is now the `_authed` guard
// (routes/guards.tsx) and LibraryClient already sets its own document title
// (app/library/client.tsx:132), so this file is a pure mount. Registered
// into the route tree from routes/agents.tsx.
import { createRoute } from '@tanstack/react-router';
import { LibraryClient } from '@/app/library/client';
import { authedRoute } from './guards';

export const libraryRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/library',
  component: LibraryClient,
});
